import { initialState } from "../notifications.slice";

const resetNotifications = () => {
    return initialState;
}

export default resetNotifications;